import { getDomain, getEnvironment, isDev } from '@library/environment/isomorphic'
import { composeFetch } from '@library/http'
import { addPath, composeRequest, goustoHeaders, setHost } from '@library/http/requests'

import type {
  DashboardExperienceOrderDeliveryDetailsResponse,
  DashboardExperienceResponse,
} from './interfaces'

const LOCAL_API_HOST = 'https://staging-api.gousto.info'

function getActivateApiHost() {
  if (isDev()) {
    return LOCAL_API_HOST
  }

  return `https://${getEnvironment()}-api.${getDomain()}`
}

const parseDashboardExperience = async (
  response: Response,
): Promise<DashboardExperienceResponse> => {
  if (!response.ok) {
    const responseMessage = await response.text()
    throw new Error(`service responded with ${response.status}: ${responseMessage}`)
  }

  return (await response.json()) as DashboardExperienceResponse
}

const parseOrderDeliveryDetails = async (
  response: Response,
): Promise<DashboardExperienceOrderDeliveryDetailsResponse> => {
  if (!response.ok) {
    const responseMessage = await response.text()
    throw new Error(`service responded with ${response.status}: ${responseMessage}`)
  }

  return (await response.json()) as DashboardExperienceOrderDeliveryDetailsResponse
}

export const fetchDashboardExperience = composeFetch(
  composeRequest(setHost(getActivateApiHost), addPath('activate/dashboard/v1'), goustoHeaders),
  parseDashboardExperience,
)

export const fetchOrderDeliveryDetails = composeFetch(
  composeRequest<string>(
    setHost(getActivateApiHost),
    addPath('activate/customerengagement/dashboard/order_delivery_details/v1'),
    addPath((orderId) => orderId),
    goustoHeaders,
  ),
  parseOrderDeliveryDetails,
)
